import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TripType } from '../../utils/tripType.enums';
import { ChipOption } from '../interfaces/trip-type-chips.interface';

@Component({
  selector: 'app-trip-type-chips',
  standalone: true,
  imports: [NgClass],
  templateUrl: './trip-type-chips.component.html',
  styleUrl: './trip-type-chips.component.css',
})
export class TripTypeChipsComponent {
  @Input() options: ChipOption[] = [
    { id: TripType.ROUND_TRIP, label: 'Ida y vuelta' },
    { id: TripType.ONE_WAY, label: 'Ida' },
    { id: TripType.OPEN_JAW, label: 'Multidestino' },
  ];
  @Input() selectedOptionId = TripType.ROUND_TRIP;
  @Output() optionSelected = new EventEmitter<TripType>();

  selectOption(id: TripType) {
    this.selectedOptionId = id;
    this.optionSelected.emit(id);
  }
}
